<template>
      <section class="C64hd">
        <div class="pK009jh img__fill ">
            <img src="../../assets/2023/rings_bg.svg" alt="">

        </div>
    <div class="container ">
<p class="Ytegx748">BACKGROUND</p>
<div class="row">
    <div class="col-sm-12 col-md-12 col-lg-5 "></div>
    <div class="col-sm-12 col-md-12 col-lg-4 ">
        <p class="jjf75hfs">
            It is a tradition of the African Union (AU) to celebrate African Integration during July of every year. The premier event for showcasing the successes achieved so far on the integration journey is the Boma of Africa, which in 2023 will be hosted in hybrid format and streamed from the Headquarters of the African Union Commission (AUC).</p>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-3 "></div>

</div>
<div class="row Yy344frt ">
    <div class="col-sm-12 col-md-12 col-lg-8 GCvd45gt __mg-auto">
        <p class="CV54hdk22">SATURDAY</p>
<p class="O0ejejP">8TH  JULY </p>   
<p class="G9V54hdk22">2023</p>
</div>
    <!-- <div class="col-8 __mg-auto Zz344frt">
      <p class="ghy7676">SATURDAY</p> 
      <p class="NV9jdu">8TH  JULY </p> 
      <p class="g86557">2023</p> 
        <p class="L84fcccc">10AM GMT /<br>
12PM CET</p>
<p class="De3453s">ONLINE <span class="yy6gs">.....</span> /  <span>ADDIS ABABA</span></p>
    </div> -->
</div>
<div class="row">
   <div class="col-8 __mg-auto ">
   <p class="L84fcccc">5pM EAT /<br>
2PM GMT</p> 
   </div>
   <div class="col-8 __mg-auto " style="padding-bottom: 3em;">
    <p class="De3453s">ONLINE <span class="yy6gs">.....</span> /  <span>ADDIS ABABA</span></p>

   </div>

</div>
    </div> 
    <div class="pK09jh img__fill">
            <img src="../../assets/2023/rings_II.png" alt="">

        </div>   
    </section>

    </template>
    
    <script>
    /* eslint-disable */
    export default {
    name:'Background'
    }
    </script>
    
    <style>
    .Hjurur75f{color:#000!important;font-size: 30px;position: relative;top:-1em;float:left}
    .G9V54hdk22{color:#000!important;font-size: 70px;position: relative;top:-25px}
    .CV54hdk22{color:#000!important;font-size: 30px;position: relative;top:1em}
    .De3453s {font-size:25px;font-family:"Montserrat-extra-bold";color:#000;}
        .yy6gs{font-size:40px;color:#00B56D;text-align: left;font-family:"Montserrat"}

    /* .C64hd{z-index: 4;} */
    .pK009jh{padding-bottom:1em}
    .Zz344frt{padding: 0;}
    .L84fcccc{font-size:25px;font-family:"Montserrat-extra-bold";color:#000;position:relative;top:0em}
    .g86557{color:#000;font-family: "MOntserrat-extra-bold";font-size:45px;position:relative;top:-0.5em}
    .ghy7676{font-size:25px;font-family:"Montserrat-extra-bold";color:#000;position:relative;top:1em}
    .GCvd45gt p{color:#00B56D;font-family: "Montserrat-extra-bold";}
    .jjf75hfs{line-height: 40px;font-family:"Montserrat";color:black;text-align: left;font-size:20px}


    @media(max-width:768px){
.GCvd45gt .G9V54hdk22{font-size:40px;}
.GCvd45gt .CV54hdk22{font-size:15px;}
.jjf75hfs{text-align: center!important;padding: 0.3em;}

}
@media (max-width: 576px) { 
.L84fcccc,.De3453s{font-size:15px!important}
.GCvd45gt .O0ejejP{font-size:40px;}
.GCvd45gt .G9V54hdk22{font-size:40px;}
.GCvd45gt .CV54hdk22{font-size:15px;}
.jjf75hfs{text-align: center!important;padding: 0.3em;}
 }

@media (min-width: 576px) { 
.GCvd45gt .O0ejejP{font-size:60px;}  
 }

@media (min-width: 768px) {   
.GCvd45gt .O0ejejP{font-size:90px;} 
.L84fcccc,.De3453s{float:left!important}

}

@media (min-width: 992px) { 
  .GCvd45gt .O0ejejP{font-size:100px;}  


 }

    </style>
